module.exports = __webpack_public_path__ + "static/img/p3.892f9ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate/patent/p3.jpg
// module id = h9Zh
// module chunks = 0